module.exports = __webpack_public_path__ + "static/crystal-red-dragon-fight-05ce84be0b105feebeb0a6f5914c284b.jpg";